export default import.meta.ROLLUP_FILE_URL_87sP2Rw1_Oil6I08t1Wj_A